import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSheetAttachment = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_7418_53835)",
		children: [/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.8 0C2.14903 0 0 2.14903 0 4.8V19.2C0 21.851 2.14903 24 4.8 24H19.2C21.851 24 24 21.851 24 19.2V6.99411C24 6.35759 23.7471 5.74714 23.2971 5.29706L18.7029 0.702944C18.2529 0.252856 17.6424 0 17.0059 0H4.8ZM20.4 10.8H10.2V13.8H20.4V10.8ZM3.6 10.8H9V13.8H3.6V10.8ZM3.6 15H9V17.4H3.6V15ZM3.6 18.6H9V20.4H3.6V18.6ZM20.4 20.4H10.2V18.6H20.4V20.4ZM10.2 15V17.4H20.4V15H10.2ZM3.6 9.6C2.93726 9.6 2.4 10.1373 2.4 10.8V20.4C2.4 21.0627 2.93726 21.6 3.6 21.6H20.4C21.0627 21.6 21.6 21.0627 21.6 20.4V10.8C21.6 10.1373 21.0627 9.6 20.4 9.6H3.6Z",
			fill: "#18A330"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M16.5 0H17.0059C17.6424 0 18.2529 0.252856 18.7029 0.702944L24 6H18.9C17.5745 6 16.5 4.92548 16.5 3.6V0Z",
			fill: "white",
			fillOpacity: .16
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_7418_53835",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgSheetAttachment;
